<template>
    <v-card class="mx-auto">
        <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
            <span> {{snackbar.message}} </span>
            <v-btn text @click="snackbar.active = false">Close</v-btn>
        </v-snackbar>        
        <v-card-text> 
            <v-container fluid>
                <v-row align="center" align-content="center" >
                    <v-col cols="12" lg="3" xl="3">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="8" class="py-0">
                                <v-radio-group v-model="sexo" label="Atualize o Sexo do Bebê">
                                    <v-radio key="M" label="Menino" value="M"></v-radio>
                                    <v-radio key="F" label="Menina" value="F" color="pink"></v-radio>
                                </v-radio-group>  
                            </v-col>
                            <v-col cols="4" class="py-0"> 
                                <v-btn color='secondary' fab large top right outlined @click="saveSex">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>                
                    </v-col> 
                    <v-divider class="mx-4" inset vertical />
                    <v-col cols="12" lg="4" xl="4">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="9" lg="8" xl="8" class="py-0">
                                <v-text-field v-model="dataRevela" type="datetime-local" label="Atualize a Data e Hora da Revelação "/>
                            </v-col>
                            <v-col cols="3" lg="4" xl="4" class="py-0"> 
                                <v-btn color='primary' fab large top right outlined @click="saveDate">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>              
                    </v-col> 
                    <v-divider class="mx-4" inset vertical />
                    <v-col cols="12" lg="4" xl="4">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="9" lg="8" xl="8" class="py-0">
                                <v-radio-group v-model="revelaType" label="Atualize o Tipo da Revelação">
                                    <v-radio key="CV" label="Chamada de Vídeo" value="CV"></v-radio>
                                    <v-radio key="FS" label="Fundo do Site" value="FS"></v-radio>
                                </v-radio-group>  
                            </v-col>
                            <v-col cols="3" lg="4" xl="4" class="py-0"> 
                                <v-btn color='secondary' fab large top right outlined @click="saveType">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>                
                    </v-col>      
                    <v-col cols="12">
                        <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="9" lg="11" xl="11" class="py-0">
                                <Address v-model="endereco" :endereco="endereco" :key="key" @closeAddress="endereco = $event"/>               
                            </v-col>
                            <v-col cols="3" lg="1" xl="1" class="py-0"> 
                                <v-btn color='primary' fab large top right outlined @click="saveAddress">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>                           
                    </v-col> 
                    <v-col cols="12">
                        <v-divider></v-divider>
                    </v-col>   
                    <v-col cols="12" lg="6" xl="6">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="8" class="py-0">
                                <v-text-field v-model="nomeMenino" label="Nome para Menino *"/> 
                            </v-col>
                            <v-col cols="4" class="py-0"> 
                                <v-btn color='secondary' fab large top right outlined @click="saveName">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>                
                    </v-col>  
                    <v-col cols="12" lg="6" xl="6">
                        <v-row justify="center" align-content="center" align="center">
                            <v-col cols="8" class="py-0">
                                <v-text-field v-model="nomeMenina" label="Nome para Menina *"/>
                            </v-col>
                            <v-col cols="4" class="py-0"> 
                                <v-btn color='primary' fab large top right outlined @click="saveName">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>     
                            </v-col>
                        </v-row>                
                    </v-col>                                                                                               
                </v-row> 
            </v-container>                            
        </v-card-text>   
    </v-card> 
</template>
<script>
import { db } from '@/main'
import $ from 'jquery'
import Address from '@/components/componentAddress';

export default {
    components: {Address},
    data: () => ({
        url: '',
        loggedIn: false,
        nome: '',
        link: '',
        key: 0,
        contagem: new Date().getTime(),
        rules: {
            required: value => !!value || 'Campo Obrigatório.', 
        },         
        listaPresentes: [],
        loading: false,
        nomeMenino: '',
        nomeMenina: '',
        nomePai: '',
        babyData: '',
        revelaType: '',
        nomeMae: '',
        dialog: false,
        sexo: '',
        snackbar: {
            'active':false,
            'color':'success',
            'message':'Deu Certo'
        },        
        apiUrl: 'https://www.googleapis.com/customsearch/v1?searchType=image&key=AIzaSyBkZBJY36Csg1dSWopBEZhceIfSz1zObSY&cx=003413523766221417157:ijmha5ktkqe&q=',
    }),
    async created(){
        this.url = sessionStorage.getItem('accessCode')
        this.loggedIn = sessionStorage.getItem('loggedIn')
        await setTimeout(() => {}, 5000);
        await db.collection('revelacoes').where('URL','==',this.url).get()
        .then((seg) => {    
            this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a})[0];
            this.listaPresentes = this.babyData.listaPresentes || []
            this.contagem = this.babyData.dataRevelacao - new Date().getTime()
            this.contagem = this.contagem < 0 ? 0 : this.contagem
            console.log("babyDataPP: ", this.babyData)
            this.nomeMenino = this.babyData.nomeMenino
            this.nomeMenina = this.babyData.nomeMenina
            this.endereco = this.babyData.endereco
            this.key += 1
            this.revelaType = this.babyData.tipoRevelacao
            // this.dataRevela = new Date(this.babyData.dataRevelacao).toISOString().slice(0,16)
            this.dataRevela  = new Date(this.babyData.dataRevelacao-(1080000*10)).toISOString().slice(0,16);

            let nomePai = this.babyData.nomeMamae
            let nomeMae = this.babyData.nomePapai

            this.babyData.FirstNameMamae =  nomePai.substring(0, nomePai.indexOf(" "))
            this.babyData.FirstNamePapai =  nomeMae.substring(0, nomeMae.indexOf(" "))  

            // console.log("roteador", this.$router)

        }).catch(function (error) {
            this.loading = false
            console.error("Error get userss: ", error);
        });              
    },
    methods:{
        saveSex(){
            if (this.sexo == '') {
                this.snackbar =  {
                    'active':true,
                    'color':'warning',
                    'message':'Selecione o Sexo do Bebê para Atualizar'
                } 
            }else{
                let sex =  {
                    'sexo': this.sexo
                }
                db.collection('revelacoes').doc(this.babyData.id).update(sex).then(async() => {
                    this.loading = false
                    this.sexo = ''
                    this.snackbar =  {
                        'active':true,
                        'color':'success',
                        'message':'Sexo Atualizado com Sucesso'
                    }                
                }).catch(function (error) {
                    this.snackbar =  {
                        'active':true,
                        'color':'error',
                        'message':'Falha ao Atualizar o Sexo do Bebê: ' + error
                    }                 
                    console.error('Error to Create Chá: ' + error)
                })  
            }
        },  
        saveData(){
            let data =  {
                'dataRevelacao': new Date(this.dataRevela).getTime(),
            }
            db.collection('revelacoes').doc(this.babyData.id).update(data).then(async() => {
                this.loading = false
                this.sexo = ''
                this.snackbar =  {
                    'active':true,
                    'color':'success',
                    'message':'Informação Atualizada com Sucesso'
                }                
            }).catch(function (error) {
                this.snackbar =  {
                    'active':true,
                    'color':'error',
                    'message':'Falha ao Atualizar a Informação: ' + error
                }                 
                console.error('Error to Update Party: ' + error)
            }) 
        },      
        saveType(){
            let data =  {
                'tipoRevelacao': this.revelaType,
            }
            db.collection('revelacoes').doc(this.babyData.id).update(data).then(async() => {
                this.loading = false
                this.sexo = ''
                this.snackbar =  {
                    'active':true,
                    'color':'success',
                    'message':'Informação Atualizada com Sucesso'
                }                
            }).catch(function (error) {
                this.snackbar =  {
                    'active':true,
                    'color':'error',
                    'message':'Falha ao Atualizar a Informação: ' + error
                }                 
                console.error('Error to Update Party: ' + error)
            }) 
        },  
        saveName(){
            let data =  {
                nomeMenina: this.nomeMenina,
                nomeMenino: this.nomeMenino, 
            }
            db.collection('revelacoes').doc(this.babyData.id).update(data).then(async() => {
                this.loading = false
                this.sexo = ''
                this.snackbar =  {
                    'active':true,
                    'color':'success',
                    'message':'Informação Atualizada com Sucesso'
                }                
            }).catch(function (error) {
                this.snackbar =  {
                    'active':true,
                    'color':'error',
                    'message':'Falha ao Atualizar a Informação: ' + error
                }                 
                console.error('Error to Update Party: ' + error)
            }) 
        },  
        saveAddress(){
            let data =  {
                endereco: this.endereco,
            }
            db.collection('revelacoes').doc(this.babyData.id).update(data).then(async() => {
                this.loading = false
                this.sexo = ''
                this.snackbar =  {
                    'active':true,
                    'color':'success',
                    'message':'Informação Atualizada com Sucesso'
                }                
            }).catch(function (error) {
                this.snackbar =  {
                    'active':true,
                    'color':'error',
                    'message':'Falha ao Atualizar a Informação: ' + error
                }                 
                console.error('Error to Update Party: ' + error)
            }) 
        },               
        removePresente(value){
            this.listaPresentes.splice(value,1)
            let listaSalvar = {
                "listaPresentes": this.listaPresentes
            }        
            db.collection('revelacoes').doc(this.babyData.id).update(listaSalvar).then(async() => {
                this.loading = false
            }).catch(function (error) {
                console.error('Error to Create Chá: ' + error)
            })                
        },
        async inserirProduto(){
                let listaProdutos = {
                    'link': this.link.substring(this.link.indexOf("//")+2, this.link.length),    
                    'imagem': ''
                }
                console.log(listaProdutos)
                this.getImage().then(async (img) => {
                    console.log("img", img)
                    listaProdutos.imagem = img.link
                    listaProdutos.nome = img.title
                    this.listaPresentes.push(listaProdutos)
                    let listaSalvar = {
                        "listaPresentes": this.listaPresentes
                    }
                    db.collection('revelacoes').doc(this.babyData.id).update(listaSalvar).then(async() => {
                        this.loading = false
                        this.nome = ''
                        this.link = ''
                        this.$refs.form.preventDefault();
                    }).catch(function (error) {
                        console.error('Error to Create Chá: ' + error)
                    })                
                })
        },
        async getImage(){
            let page = this.link.substring(this.link.indexOf('.')+1,this.link.indexOf('.com')+4)
            let nome = this.link.substring(this.link.lastIndexOf('/')+1,this.link.indexOf('?'))
            if (nome.length == 0)
                nome = this.link.substring(this.link.lastIndexOf('.br')+4,this.link.indexOf('?'))        

            if(nome.split("/").length > 2){
                nome = this.link.substring(this.link.lastIndexOf('.br')+4,this.link.length -1)
                nome = nome.substring(nome.lastIndexOf('.br')+4, nome.indexOf('/'))
            }

            console.log("teste", page,nome)
            let teste
            await $.getJSON(this.apiUrl+ page + ' ' + nome, async function(data){
                console.log("items", data)
                teste = await data.items[0]
            })
            return teste
        }
    }
    // <a href='https://br.freepik.com/fotos-vetores-gratis/bebe'>Bebê vetor criado por stockgiu - br.freepik.com</a> 4871100
    // <a href='https://br.freepik.com/fotos-vetores-gratis/logotipo'>Logotipo vetor criado por freepik - br.freepik.com</a> plantilha
    // <a href='https://br.freepik.com/fotos-vetores-gratis/carro'>Carro vetor criado por elsystudio - br.freepik.com</a> artigos de bebe
    // https://br.freepik.com/vetores-gratis/modelo-de-logotipo-adoravel-loja-de-bebe-com-estilo-moderno_3490643.htm#query=bebe&position=3 
}
</script>